import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  getRequestWithToken,
  getRequest,
  getRequestWithTokenV3,
} from "../../utils/ApiRequests";
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import { Box, Container, Grid, Typography } from "@mui/material";
import { GlobalContext } from "../../components/GlobalStateProvide/GlobalStateProvider";
import "./candidates.scss";
import BackBtn from "../../components/backButton/BackBtn";
// import { TimeDisplay } from "../../utils/functions";
const CandidateDetails = () => {
  const { candidateId } = useParams();
  const [candidateData, setCandidateData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const { handleSnackBar } = useContext(GlobalContext);
  const [languages, setLanguages] = useState([]);
  const getCandidateDetails = async () => {
    try {
      let response = await getRequestWithToken(
        `admin/candidate/${candidateId}`
      );
      setCandidateData(response.data.data);
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.message || error?.message,
        "error"
      );
      setShowLoader(false);
    }
  };

  useEffect(() => {
    getCandidateDetails();
  }, [candidateId]);

  // useEffect(() => {
  //   console.log("data response: ", JSON.stringify(candidateData));
  // }, [candidateData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const regex = /^(\d{2})[-/](\d{2})[-/](\d{4})$/;
    const match = dateString.match(regex);
    if (match) {
      return dateString?.replaceAll("-", "/");
    }

    const date = new Date(dateString);
    return date.toLocaleDateString(); // Adjust the format as needed
  };
  const getCandidateExperience = (experience) => {
    if (!experience) return "";
    let [exp_y, exp_m] = experience.split(".");
    exp_y = !exp_y ? "" : exp_y + " years";
    exp_m = !exp_m ? "" : exp_m + " months";
    return exp_y + " " + exp_m;
  };

  const getGender = (data) => {
    if (data === 1) return "Female";
    else if (data === 2) return "Male";
    else if (data === 4) return "Other";
    else return "-";
  };

  const getAssetsOwned = (data) => {
    const assets_ownedRequired = [
      { id: 1, label: "Two Wheeler", value: 1 },
      { id: 2, label: "Four Wheeler", value: 2 },
      { id: 3, label: "Basic Phone", value: 3 },
      { id: 4, label: "Smartphone", value: 4 },
      { id: 5, label: "Own Laptop", value: 5 },
      { id: 6, label: "Internet Connection", value: 6 },
      { id: 7, label: "Tools and Requirement", value: 7 },
    ];
    if (!data || typeof data !== 'object') return "-";
    const selectedAssets = Object.keys(data)
      .filter(key => data[key] === true)
      .map(key => assets_ownedRequired.find(asset => asset.id === parseInt(key))?.label)
      .filter(Boolean);
    return selectedAssets.length > 0 ? selectedAssets.join(", ") : "-";
  };

  const getDocument = (data) => {
    const governmentDocumentsRequired = [
      { id: 1, label: "Aadhaar Card", value: 1 },
      { id: 2, label: "PAN Card", value: 2 },
      { id: 3, label: "E-Shram Card", value: 3 },
      {
        id: 4,
        label: "Bank Account with passbook",
        value: 4,
      },
      { id: 5, label: "Education Certificate", value: 5 },
      { id: 6, label: "Driving License", value: 6 },
    ];
    if (!data || typeof data !== 'object') return "-";
    const selectedDocs = Object.keys(data)
      .filter(key => data[key] === true)
      .map(key => governmentDocumentsRequired.find(doc => doc.id === parseInt(key))?.label)
      .filter(Boolean);
    return selectedDocs.length > 0 ? selectedDocs.join(", ") : "-";
  };

  const getQualification = (data) => {
    const educationQualificationData = [
      { id: 1, label: "10th", value: 2 },
      { id: 2, label: "12th", value: 3 },
      { id: 3, label: "Diploma after 10th", value: 4 },
      {
        id: 4,
        label: "Diploma after 12th",
        value: 5,
      },
      { id: 5, label: "Graduate", value: 6 },
      { id: 6, label: "Post Graduate", value: 7 },
      { id: 8, label: "ITI", value: 8 },
    ];

    return (
      educationQualificationData.find((asset) => asset.value === data)?.label ||
      "-"
    );
  };
  const getCertificate = (data) => {
    const certificateSpeciliazationData = [
      { id: 0, label: "None", value: 0 },
      { id: 1, label: "ITI", value: 1 },
      { id: 2, label: "DDUGKY", value: 2 },
      { id: 3, label: "Skill India", value: 3 },
    ];

    if (!data || !Array.isArray(data)) return "-";
    const selectedCerts = data
      .map(certId => certificateSpeciliazationData.find(cert => cert.value === certId)?.label)
      .filter(Boolean);
    return selectedCerts.length > 0 ? selectedCerts.join(", ") : "-";
  };


  const getLanguageData = async () => {
    try {
      let languageData = await getRequestWithTokenV3(`candidate/languages`);
      if (languageData.data && Array.isArray(languageData.data.data)) {
        setLanguages(languageData.data.data);
      } else {
        setLanguages([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   getLanguageData();
  // }, []);

  const getLanguage = (data) => {
    return languages?.find((asset) => asset.id === data)?.label || "-";
  };

  const getEmployementStatus = (data) => {
    const employementStatus = [
      { id: 0, label: "-", value: "-" },
      { id: 1, label: "Fresher", value: "fresher" },
      {
        id: 2,
        label: "unemployed & Experienced",
        value: "unemployed & experienced",
      },
      { id: 3, label: "Working Full Time", value: "working full time" },
      { id: 4, label: "Working Part Time", value: "working part time" },
    ];
    return employementStatus.find((asset) => asset.id === data)?.label || "-";
  };

  const getWorkMode = (data) => {
    const workMode = [
      {
        id: 1,
        label: "Field Job",
      },
      {
        id: 2,
        label: "Work from Office",
      },
      {
        id: 3,
        label: "Work from Home",
      },
      {
        id: 4,
        label: "Hybrid",
      },
    ];
    if (!data || typeof data !== 'object') return "-";
    const selectedModes = Object.keys(data)
      .filter(key => data[key] === true)
      .map(key => workMode.find(mode => mode.id === parseInt(key))?.label)
      .filter(Boolean);
    return selectedModes.length > 0 ? selectedModes.join(", ") : "-";
  };

  const getPastworkExperience = (months) => {

    const pastworkExp = [
      { id: 0, label: "Fresher", value: 0 },
      { id: 1, label: "<1 year", value: 12 },
      { id: 2, label: "1-3 years", value: 36 },
      { id: 3, label: "3+ years", value: 48 },
    ];

    const labelString = pastworkExp.find((exp) => months <= exp.value)?.label || "3+ years";
    return labelString;
  };

  const getMaritalStatus = (data) => {
    if (data === 1) return "Married";
    if (data === 2) return "Unmarried";
    if (data === 3) return "Other";
  };

  const formatDuration = (item) => {
    const months = item?.duration?.months ?? 0;
    const years = item?.duration?.year ?? 0;
    return ` ${years} year${years !== 1 ? "s" : ""} ${months} month${months !== 1 ? "s" : ""
      }`;
  };

  const getLearningMode = (data) => {
    let LearningMode = [
      { id: 1, label: "Classroom" },
      {
        id: 2,
        label: "E-learning/correspondance",
      },
      {
        id: 3,
        label: "Hybrid",
      },
    ];
    return LearningMode.find((asset) => asset.id === data)?.label || "-";
  };

  const getEngagementType = (data) => {
    if (!data) return "-";
    else if (data === 1) return "Full Time";
    else if (data === 2) return "Part Time";
    else return "-";
  };

  const getExpectedSalary = (data) => {
    const expectedSalaryData = [
      { id: 0, label: "₹8K - ₹12K", value: 0 },
      { id: 1, label: "₹12K - ₹18K", value: 1 },
      { id: 2, label: "₹18K - ₹25K", value: 2 },
      { id: 3, label: "₹25K+", value: 3 },
      { id: 4, label: "NA", value: 4 },
    ];
    return expectedSalaryData.find((salary) => salary.value === data)?.label || "-";
  };

  const getWorkLocationPreference = (data) => {
    console.log("work location preference data: ", data);
    if (data == 1) return "Pass";
    else if (data == 2) return "Thoda Dur";
    else if (data == 3) return "Bahut Dur";
    else return "-";
  };

  return showLoader ? (
    <ReusableLoader />
  ) : (
    <Box className="create-candidates-section">
      <Container>
        <Box className="create-candidates">
          <Box className="headingPlusBackBtn">
            <BackBtn />
            <h1 className="formHeadings" id="topEle">
              {" "}
              Candidate Details
            </h1>
          </Box>
          <Box className="create-candidates-form-wrapper">
            <Box className="backgroundStyle">
              <Typography
                variant="h6"
                component="h3"
                gutterBottom
                className="formSubSectionHeading"
                style={{ fontWeight: 600, marginBottom: '20px', color: '#1976d2' }}
              >
                Personal Details
              </Typography>
              <Grid container spacing={2} className="cstmFormGridEmployer">
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control" style={{ padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#555', marginBottom: '5px' }}>Full Name</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                        fontSize: '15px',
                        color: '#333'
                      }}
                    >
                      {candidateData.user_name || "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Mobile Number</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {candidateData.phone_number || "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Email ID</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {candidateData.email}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Date of Birth</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {formatDate(candidateData.dob)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Gender </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {getGender(candidateData.gender)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Pincode </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {candidateData?.pincode || "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Assets Owned</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {getAssetsOwned(candidateData?.assets_owned)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Document Posses</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                    >
                      {getDocument(candidateData?.documents_owned)}
                    </Typography>
                  </Box>
                </Grid>

              </Grid>
            </Box>

            <Box className="backgroundStyle" style={{ marginTop: '30px' }}>
              <Typography
                variant="h6"
                component="h3"
                gutterBottom
                className="formSubSectionHeading"
                style={{ fontWeight: 600, marginBottom: '20px', color: '#1976d2' }}
              >
                Skill Details
              </Typography>
              <Grid container spacing={2} className="cstmFormGridEmployer">

                {candidateData?.education_information?.length > 0 && (
                  <>


                    <Grid item xs={12} sm={6} md={4}>
                      <Box className="form-control">
                        <Typography variant="subtitle1">
                          Qualification
                        </Typography>
                        {candidateData?.education_information?.map((item) => {
                          return (
                            <Typography
                              variant="subtitle2"
                              style={{
                                paddingLeft: "5px",
                                textTransform: "capitalize",
                              }}
                            >
                              {getQualification(item?.qualification)}
                            </Typography>
                          );
                        })}
                      </Box>
                    </Grid>


                  </>
                )}


                {candidateData?.certification && (

                  <Grid item xs={12} sm={6} md={4}>
                    <Box className="form-control">
                      <Typography variant="subtitle1">
                        Certificate of Vocation or Skill
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{ paddingLeft: "5px" }}
                      >
                        {getCertificate(candidateData?.certification)}
                      </Typography>
                    </Box>
                  </Grid>


                )}

              </Grid>
            </Box>

            <Box className="backgroundStyle" style={{ marginTop: '30px' }}>
              <Typography
                variant="h6"
                component="h3"
                gutterBottom
                className="formSubSectionHeading"
                style={{ fontWeight: 600, marginBottom: '20px', color: '#1976d2' }}
              >
                Work Details
              </Typography>
              <Grid container spacing={2} className="cstmFormGridEmployer">
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Employment Status
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                    >
                      {getEmployementStatus(
                        candidateData?.current_employment_status
                      )}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Total work experience
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ paddingLeft: "5px" }}
                    >
                      {/* {getCandidateExperience(
                        candidateData?.past_work_experience
                      )} */}
                      {getPastworkExperience(candidateData?.past_work_experience)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">Work Mode</Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                    >
                      {getWorkMode(candidateData?.work_mode_choice)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Engagement Type Preference
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                    >
                      {getEngagementType(
                        candidateData?.engagement_type
                      )}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Work Location Preferences
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                    >
                      {candidateData?.migrate_concern ? "Other cities also" : "Only in my city"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Number of Jobs Done
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                    >
                      {candidateData?.past_job_count || "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Expected Salary
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                      }}
                    >
                      {getExpectedSalary(candidateData?.expectedSalary)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={12}>
                  <Box className="form-control">
                    <Typography varaint="subtitle1">
                      Job Expertise
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingLeft: "5px",
                      }}
                    >
                      {candidateData?.job_expertise && Array.isArray(candidateData.job_expertise)
                        ? [...new Set(candidateData.job_expertise.map(item => item.name))].join(", ")
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>


              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CandidateDetails;
